import { render, staticRenderFns } from "./NewsBlock.vue?vue&type=template&id=53ecebc4&"
import script from "./NewsBlock.vue?vue&type=script&lang=js&"
export * from "./NewsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports